import Api from '@/api/Api'
import DownloadApi from '@/api/DownloadApi'
import toast from '@/mixins/toast'
import router from '@/router'

export default {
    
    getPurposes (payload) {
        return Api().get('/purposes/'+ payload)       
    },
    getRequestTypes () {
        return Api().get('/request-type')
    },
    getEmergencyNotification (payload) {
        return Api().get('/emergency-notification/'+ payload)
    },
    getAgencies () {
        return Api().get('/agency')
    },
    addAgency (payload) {
        return Api().post('/agency', payload).then( (response) => {
            return response.data
        })
        .catch( error => { 
            toast.error(error.response.data.message, "<b>"+ error.response.data.status +":</b> "+ error.response.data.title)
        })
    },
	getStatuses () {
		return Api().get('/statuses')
	},
	getStatusById (param) {
		return Api().get('/status?'+ param)
	},
    getAirTypeById (payload) {
        return Api().get('/air-type/'+ payload)
    },
    getFacilityType (payload) {
        return Api().get('/facility-type')       
    },
    getSiteType (payload) {
        return Api().get('/site-type')
    },
    // get array of photos
    fetchAttachment (payload) {
        return Api().get('/upload/'+ payload+'/summary').then( (response) => {
                return response.data
            }) 
            .catch( error => { 
                console.log(error) 
                toast.error(error.response.data.message, "<b>"+ error.response.data.status +":</b> "+ error.response.data.title)
            })
    },

    // get array of photos
    fetchDLTAttachment (payload) {
        return Api().get('/upload/'+ payload+'/dlt').then( (response) => {
                return response.data
            }) 
            .catch( error => { 
                console.log(error) 
                toast.error(error.response.data.message, "<b>"+ error.response.data.status +":</b> "+ error.response.data.title)
            })
    },

    download (item) {
        return DownloadApi().get('/download/'+ item.id, {responseType: 'arraybuffer'}).then( (response) => {
               
               const filename = item.filename
               const url = window.URL.createObjectURL(new Blob([response.data]));
               const link = document.createElement('a');
               link.href = url;
               link.setAttribute('download', filename.substring(filename.lastIndexOf('/')+1)); 
               document.body.appendChild(link);
               link.click();              
            })
            .catch( error => {
                // console.log(error)
                // toast.error( error.data.message )
                if (error.response) {
                      // The request was made and the server responded with a status code
                      // that falls out of the range of 2xx
                      console.log(error.response.data);
                      console.log(error.response.status);
                      console.log(error.response.headers);

                      if (error.response.status = 401) {
                          toast.error( "Your session has expired.  Please login again.", "401: Unauthorized")
                          router.replace('/login')
                      }

                    } else if (error.request) {
                      // The request was made but no response was received
                      // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                      // http.ClientRequest in node.js
                      console.log(error.request)
                      toast.error( "An unexpected error occurred while processing the request.", "500: Backend Error")
                    } else {
                      // Something happened in setting up the request that triggered an Error
                      console.log('Error', error.message);
                    }
            })
    },

    downloadKML (target) {
        return DownloadApi().get('/download/nsl2kml/'+ target, {responseType: 'arraybuffer'}).then( (response) => {
               
               const filename = target
               const url = window.URL.createObjectURL(new Blob([response.data]));
               const link = document.createElement('a');
               link.href = url;
               link.setAttribute('download', filename.substring(filename.lastIndexOf('/')+1)); 
               document.body.appendChild(link);
               link.click();              
            })
            .catch( error => {
                // console.log(error)
                // toast.error( error.data.message )
                if (error.response) {
                      // The request was made and the server responded with a status code
                      // that falls out of the range of 2xx
                      console.log(error.response.data);
                      console.log(error.response.status);
                      console.log(error.response.headers);
                    } else if (error.request) {
                      // The request was made but no response was received
                      // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                      // http.ClientRequest in node.js
                      console.log(error.request)
                      toast.error( "An unexpected error occurred while processing the request.", "500: Backend Error")
                    } else {
                      // Something happened in setting up the request that triggered an Error
                      console.log('Error', error.message);
                    }
            })
    },

    downloadCSV (target) {
        return DownloadApi().get('/download/pax2csv/'+ target, {responseType: 'arraybuffer'}).then( (response) => {
               
               const filename = target
               const url = window.URL.createObjectURL(new Blob([response.data]));
               const link = document.createElement('a');
               link.href = url;
               link.setAttribute('download', filename.substring(filename.lastIndexOf('/')+1)); 
               document.body.appendChild(link);
               link.click();              
            })
            .catch( error => {
                // console.log(error)
                // toast.error( error.data.message )
                if (error.response) {
                      // The request was made and the server responded with a status code
                      // that falls out of the range of 2xx
                      console.log(error.response.data);
                      console.log(error.response.status);
                      console.log(error.response.headers);
                    } else if (error.request) {
                      // The request was made but no response was received
                      // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                      // http.ClientRequest in node.js
                      console.log(error.request)
                      toast.error( "An unexpected error occurred while processing the request.", "500: Backend Error")
                    } else {
                      // Something happened in setting up the request that triggered an Error
                      console.log('Error', error.message);
                    }
            })
    },

    downloadTrackingSheet (target) {
        return DownloadApi().get('/download/trackingsheet/'+ target, {responseType: 'arraybuffer'}).then( (response) => {
               
               const filename = target
               const url = window.URL.createObjectURL(new Blob([response.data]));
               const link = document.createElement('a');
               link.href = url;
               link.setAttribute('download', filename.substring(filename.lastIndexOf('/')+1)); 
               document.body.appendChild(link);
               link.click();              
            })
            .catch( error => {
                // console.log(error)
                // toast.error( error.data.message )
                if (error.response) {
                      // The request was made and the server responded with a status code
                      // that falls out of the range of 2xx
                      console.log(error.response.data);
                      console.log(error.response.status);
                      console.log(error.response.headers);
                    } else if (error.request) {
                      // The request was made but no response was received
                      // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                      // http.ClientRequest in node.js
                      console.log(error.request)
                      toast.error( "An unexpected error occurred while processing the request.", "500: Backend Error")
                    } else {
                      // Something happened in setting up the request that triggered an Error
                      console.log('Error', error.message);
                    }
            })
    }    
}


// WEBPACK FOOTER //
// ./src/api/CommonService.js